/**
 * 翻译历史服务
 * 提供翻译历史记录管理的核心业务逻辑
 */
import { LoggerService } from '../../logging/services/logger.service.js';
/**
 * 翻译历史服务类
 * 负责处理翻译历史相关的核心逻辑
 */
export class TranslationHistoryService {
    /**
     * 私有构造函数，实现单例模式
     */
    constructor(translationStorage) {
        this.logger = LoggerService.getInstance();
        this.translationStorage = translationStorage;
    }
    /**
     * 获取实例
     */
    static getInstance(translationStorage) {
        if (!TranslationHistoryService.instance) {
            TranslationHistoryService.instance = new TranslationHistoryService(translationStorage);
        }
        return TranslationHistoryService.instance;
    }
    /**
     * 为指定文档加载翻译历史
     */
    async loadTranslationsForDocument(identity) {
        if (!identity || !identity.id)
            return [];
        try {
            const words = await this.translationStorage.getTranslationsForTextDocument(identity);
            return words;
        }
        catch (error) {
            this.logger.error('Failed to load translation history', { error, data: { identity } });
            throw error;
        }
    }
    /**
     * 获取特定位置的翻译记录
     */
    async getTranslation(identity, selectionData) {
        try {
            const result = await this.translationStorage.getTranslation(identity, selectionData);
            return result || null;
        }
        catch (error) {
            this.logger.error('Failed to get translation record', {
                error,
                data: { identity, selectionData },
            });
            throw error;
        }
    }
    /**
     * 保存翻译记录
     */
    async saveTranslation(translation) {
        try {
            const savedId = await this.translationStorage.saveTranslation(translation);
            return savedId;
        }
        catch (error) {
            this.logger.error('Failed to save translation record', { error, data: { translation } });
            throw error;
        }
    }
    /**
     * 搜索词汇
     */
    async searchVocabulary(searchText, options) {
        try {
            return await this.translationStorage.searchVocabulary(searchText, options);
        }
        catch (error) {
            this.logger.error('Failed to search vocabulary', { error, data: { searchText } });
            throw error;
        }
    }
    /**
     * 删除词汇项
     */
    async deleteVocabularyItem(id) {
        try {
            return await this.translationStorage.deleteVocabularyItem(id);
        }
        catch (error) {
            this.logger.error('Failed to delete vocabulary item', { error, data: { id } });
            throw error;
        }
    }
    /**
     * 获取所有词汇
     */
    async getAllVocabulary(options) {
        try {
            return await this.translationStorage.getAllVocabulary(options);
        }
        catch (error) {
            this.logger.error('Failed to get all vocabulary', { error });
            throw error;
        }
    }
    /**
     * 获取词汇统计信息
     */
    async getVocabularyStats() {
        try {
            const stats = await this.translationStorage.getVocabularyStats();
            return stats;
        }
        catch (error) {
            this.logger.error('Failed to get vocabulary stats', { error });
            throw error;
        }
    }
}
TranslationHistoryService.instance = null;
//# sourceMappingURL=TranslationHistoryService.js.map